// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   MdSearch,
//   MdClear,
//   MdDownload,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFirstPage,
//   MdLastPage,
// } from "react-icons/md";

// import { getArticles, deleteArticle } from "api/article.api";
// import ArticleTable from "components/articles/ArticleTable";
// import BulkImportButton from "components/common/BulkImportButton";


// export default function Articles() {
//   const [data, setData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const userId = "69579c6190a653b640e65639";

//   const fetchData = async () => {
//   const res = await getArticles({
//     company_id: selectedOrganizer,
//   });

//   setData(Array.isArray(res.data?.data) ? res.data.data : []);
// };


//   useEffect(() => {
//     fetchData();
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };

//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   const handleDelete = async (id) => {
//     await deleteArticle(id, {
//       is_deleted: true,
//       deleted_by: userId,
//     });
//     fetchData();
//   };

//   const filteredData = data.filter(
//     (item) =>
//       item.title?.toLowerCase().includes(search.toLowerCase()) ||
//       item.author?.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredData.length / limit);

//   const paginatedData = filteredData.slice(
//     (page - 1) * limit,
//     page * limit
//   );

//   const exportCSV = () => {
//     const headers = ["Title", "Author", "Status", "Published Date"];

//     const rows = filteredData.map((a) => [
//       a.title,
//       a.author,
//       a.status,
//       a.published_date,
//     ]);

//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers, ...rows].map((r) => r.join(",")).join("\n");

//     const link = document.createElement("a");
//     link.href = encodeURI(csvContent);
//     link.download = "articles.csv";
//     link.click();
//   };

//   return (
//     <div className="p-4">
//       <div className="flex justify-between items-center mb-4">
//         <div className="flex items-center gap-2">
//           <div className="relative">
//             <MdSearch className="absolute left-3 top-2.5 text-gray-400 text-lg" />
//             <input
//               type="text"
//               placeholder="Search articles..."
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//               className="pl-10 pr-8 py-2 border rounded-md text-sm w-64"
//             />
//             {search && (
//               <button
//                 onClick={() => setSearch("")}
//                 className="absolute right-2 top-2.5 text-gray-400"
//               >
//                 <MdClear />
//               </button>
//             )}
//           </div>

//           <button
//             onClick={exportCSV}
//             className="flex items-center gap-1 px-2 py-1 bg-green-500 text-white rounded-lg"
//           >
//             <MdDownload /> CSV
//           </button>
//         </div>
//          <div className="flex items-center gap-2">
//             <BulkImportButton module="articles" label="Import Articles" onSuccess={fetchData} companyId={selectedOrganizer} />
//               <Link
//                 to="/admin/articles/create"
//                 className="bg-brand-500 text-white px-4 py-2 rounded-md text-sm font-medium"
//               >
//                 Add Article
//               </Link>
//         </div>
//       </div>

//       <div className="bg-white rounded-md shadow-sm border">
//         <ArticleTable
//           data={paginatedData}
//           onDelete={handleDelete}
//           onRefresh={fetchData}
//         />

//         <div className="flex justify-between items-center px-4 py-3 border-t text-sm">
//           <span className="text-gray-500">
//             {filteredData.length} total
//           </span>

//           <div className="flex items-center gap-1">
//             <select
//               value={limit}
//               onChange={(e) => {
//                 setLimit(Number(e.target.value));
//                 setPage(1);
//               }}
//               className="border rounded-md px-2 py-2 text-sm"
//             >
//               <option value={10}>10 / page</option>
//               <option value={25}>25 / page</option>
//               <option value={50}>50 / page</option>
//             </select>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(1)}
//               className="p-2 border rounded"
//             >
//               <MdFirstPage />
//             </button>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(page - 1)}
//               className="p-2 border rounded"
//             >
//               <MdChevronLeft />
//             </button>

//             <span className="px-3 font-medium">
//               {page} / {totalPages || 1}
//             </span>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//               className="p-2 border rounded"
//             >
//               <MdChevronRight />
//             </button>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(totalPages)}
//               className="p-2 border rounded"
//             >
//               <MdLastPage />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MdSearch, MdDownload, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import BulkImportButton from "components/common/BulkImportButton";
import SampleDownloadButton from "components/common/SampleDownloadButton";
import { getArticles, deleteArticle } from "api/article.api";
import ArticleTable from "components/articles/ArticleTable";
import { InputField } from "components/FormFields";
import CustomButton from "components/CustomButton";
import Alert from "components/common/Alert";
import SideDrawerModal from "components/SideDrawerModal";
import ViewArticleDetails from "components/articles/ViewArticleDetails";

export default function Articles() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [alert, setAlert] = useState("");
  const [userId, setUserId] = useState("69579c6190a653b640e65639");
  const [role, setRole] = useState("admin");

  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [paginationInfo, setPaginationInfo] = useState({
    totalArticles: 0,
    totalPages: 1,
  });
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (userData._id) setUserId(userData._id);
    if (userData.role) setRole(userData.role);
  }, []);

  // Debounce search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  // Fetch articles
  const fetchData = useCallback(async () => {
    if (!selectedOrganizer) return;

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      setLoading(true);
      const res = await getArticles({
        company_id: selectedOrganizer,
        page,
        limit,
        search: debouncedSearch,
        signal: controller.signal,
      });

      const payload = res?.data || {};
      const list =
        payload.articles ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);
      setPaginationInfo({
        totalArticles: payload.pagination?.totalArticles || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") return;
      console.error("Failed to fetch articles:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const filteredData = data.filter((item) => {
    return [
      item.title,
      item.author,
      item.status,
      item.exhibitor_id?.title,
    ]
      .join(" ")
      .toLowerCase()
      .includes(debouncedSearch.toLowerCase());
  });

  const viewButton = (articleData) => {
    setSelectedArticle(articleData);
    setIsViewOpen(true);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((item, idx) => item._id || idx));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDelete = async (id) => {
    await deleteArticle(id, {
      is_deleted: true,
      deleted_by: userId,
    });
    setAlert("Article deleted successfully");
    fetchData();
  };

  const handleExportCSV = () => {
    const exportData =
      selectedRows.length > 0
        ? filteredData.filter((item, idx) =>
            selectedRows.includes(item._id || idx)
          )
        : filteredData;

    if (!exportData.length) return;

    const headers = ["Title", "Exhibitor", "Author", "Published Date", "Status"];
    const safeStr = (val) => String(val || "").replace(/"/g, '""');

    const rows = exportData.map((a) => [
      `"${safeStr(a.title)}"`,
      `"${safeStr(a.exhibitor_id?.title)}"`,
      `"${safeStr(a.author)}"`,
      `"${safeStr(a.published_date)}"`,
      `"${safeStr(a.status)}"`,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `articles_${
        selectedRows.length > 0 ? "selected" : "all"
      }_${Date.now()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <TablePageLayout>
      {role !== "exhibitor" && (
        <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col">
            <InputField
              label="SEARCH"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search articles..."
              icon={<MdSearch className="text-lg text-gray-400" />}
            />
          </div>

          <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
            <CustomButton
              label={
                selectedRows.length > 0
                  ? `Export Selected (${selectedRows.length})`
                  : "Export CSV"
              }
              icon={MdDownload}
              iconPos="left"
              variant="outline"
              color="#1A1A1A"
              borderColor="#02a9e0"
              disabled={filteredData.length === 0}
              onClick={handleExportCSV}
            />

            {/* <SampleDownloadButton module="articles" /> */}

            {/* <BulkImportButton
              module="articles"
              label="Import Articles"
              onSuccess={fetchData}
              companyId={selectedOrganizer}
            /> */}

            <CustomButton
              label="Add Article"
              icon={MdAddBox}
              iconPos="right"
              variant="solid"
              color="#02a9e0"
              onClick={() => navigate("/admin/articles/create")}
            />
          </div>
        </div>
      )}

      {alert && (
        <Alert type="success" message={alert} onClose={() => setAlert("")} />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading articles...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <ArticleTable
            data={data}
            startIndex={(page - 1) * limit}
            onRefresh={fetchData}
            onDelete={handleDelete}
            selectedRows={selectedRows}
            onSelectRow={handleSelectRow}
            onSelectAll={handleSelectAll}
            viewButton={viewButton}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalArticles}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      <SideDrawerModal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title={selectedArticle?.title || "Article Details"}
        width="600px"
      >
        <ViewArticleDetails data={selectedArticle} />
      </SideDrawerModal>
    </TablePageLayout>
  );
}